(() => {
  if (customElements.get('m4g-arrivals-notify')) return;
  class ArrivalsNotify extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      this.drawer = this.querySelector('x-drawer');
      this.formId = this.drawer?.querySelector('form')?.id;
      this.sessionKey = this.dataset.sessionKey || 'm4g-arrivals-x-seen';
      if (!this.drawer) return;
      const { signal } = this.events;
      const onHash = () => { if (this.matchesHash()) this.drawer.show(); };
      customElements.whenDefined('x-drawer').then(() => {
        if (signal.aborted || !this.isConnected) return;
        window.addEventListener('hashchange', onHash, { signal });
        document.addEventListener('visibilitychange', () => this.queueAutoOpen(), { signal });
        this.drawer.addEventListener('toggle', () => {
          if (this.drawer.open) this.rememberShown();
        }, { signal });
        this.drawer.addEventListener('dialog:after-hide', () => {
          if (this.matchesHash()) history.replaceState(history.state, '', location.pathname + location.search);
        }, { signal });
        onHash();
        this.queueAutoOpen();
      });
    }
    matchesHash() {
      return location.hash === '#arrivals-x' || (this.formId && location.hash === '#' + this.formId);
    }
    wasShown() {
      if (this.seen) return true;
      try {
        return document.cookie.split(';').some(value => value.trim() === this.sessionKey + '=1');
      } catch { return false; }
    }
    rememberShown() {
      this.seen = true;
      clearTimeout(this.autoTimer);
      try {
        document.cookie = this.sessionKey + '=1; Path=/; SameSite=Lax; Secure';
      } catch { /* Closing still works when browser storage is unavailable. */ }
    }
    queueAutoOpen() {
      clearTimeout(this.autoTimer);
      if (this.dataset.autoOpen !== 'index' || window.Shopify?.designMode ||
          this.wasShown() || this.drawer.open || document.visibilityState !== 'visible') return;
      this.autoTimer = setTimeout(() => {
        if (!this.isConnected || this.wasShown() || this.drawer.open ||
            document.visibilityState !== 'visible' || document.documentElement.classList.contains('lock') ||
            document.querySelector('dialog[open]')) return;
        this.drawer.show();
      }, 3000);
    }
    disconnectedCallback() {
      clearTimeout(this.autoTimer);
      this.events?.abort();
      if (this.drawer?.open) this.drawer.hide();
    }
  }
  customElements.define('m4g-arrivals-notify', ArrivalsNotify);
})();
